export const AIR_DENOMINATOR = 'AIR_DENOMINATOR';
export const OCEAN_DENOMINATOR = 'OCEAN_DENOMINATOR';
export const MONTHLY_COMMISSION = 'MONTHLY_COMMISSION';